import { createSelector } from 'reselect'
import filter from 'lodash/filter'
import at from 'lodash/at'
import get from 'lodash/get'

export const issuesSelector = (state, paginationKey, id) => {
  const pagination = get(state, `pagination.${paginationKey}.${id}`, {})

  return at(state.issues, pagination.ids || [])
}

export const areaFilter = (state, locationId) => {
  return (
    state.areas.currentFilter || get(state, `form.locationIssuesAreaFilter.areaId.value`)
  )
}

export const needsWorkSelector = statusSelectorFactory('needs_work')
export const needsReviewSelector = statusSelectorFactory('needs_review')
export const permanentSelector = statusSelectorFactory('permanent')
export const resolvedSelector = statusSelectorFactory('resolved')

function filterIssues (issues, status, area) {
  if (area) {
    return filter(issues, { status, area })
  } else {
    return filter(issues, { status })
  }
}

function statusSelectorFactory (status) {
  return createSelector(
    [issuesSelector, areaFilter],
    (issues, area) => filterIssues(issues, status, area)
  )
}



// WEBPACK FOOTER //
// ./src/selectors/issue-selectors.js